import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreData } from 'src/app/tools/core-data';

import { DomSanitizer } from '@angular/platform-browser';
import { ENavigationRoute } from 'src/app/models/enum/navigation-route';
import { ENavigationErrorType } from 'src/app/models/navigation-error-type';
import { db, PictureEntity } from '../../db/db';

@Component({
    selector: 'app-picture-viewer',
    templateUrl: './picture-viewer.component.html',
    styleUrls: ['./picture-viewer.component.scss']
})
export class PictureViewerComponent implements OnInit {

    LocalImageURL: string;
    PhotoWidth = window.innerWidth;

    constructor(
        private route: ActivatedRoute,
        private router: Router) { }

    async ngOnInit() {
        if (!this.route.snapshot.params.interventionCode || !this.route.snapshot.params.type) {
            this.router.navigate([ENavigationRoute.Error, { type: ENavigationErrorType.URL }]);
            return;
        }

        const code = this.route.snapshot.params.interventionCode;
        const type = Number(this.route.snapshot.params.type);
        // TODO NEW DB
        // this.pictureDbService.getPicture(this.pictureDbService.generatePictureKey(code, type)).subscribe((x: any) => {
        //     // `data:image/png;base64,${x.data}`
        //     this.LocalImageURL = `${x.data}`;
        // });

        const doc = await db.getPictureByType(await db.getInterventionByCode(code), type) as PictureEntity;
        this.LocalImageURL = `${doc.Data}`;
    }
}
